(() => {
  const mobileQuery = window.matchMedia('(max-width: 749px)');

  const stabilizeAnnouncement = () => {
    if (!mobileQuery.matches) return;

    const wrapper = document.querySelector('.announcement-bar-slider');
    if (!wrapper || wrapper.querySelector('.nmw-mobile-announcement')) return;

    const link = document.createElement('a');
    link.className = 'nmw-mobile-announcement focus-inset';
    link.href = '#newsletter-signup';
    link.textContent = 'Get 10% off your first order.';

    wrapper.replaceChildren(link);
  };

  const buildProductDetails = (productInfo) => {
    if (!mobileQuery.matches || productInfo.dataset.nmwDetailsReady === 'true') return;

    const container = productInfo.querySelector('.product__info-container');
    const description = container?.querySelector('.product__description');
    if (!container || !description) return;

    const areaHeading = Array.from(description.children).find(
      (element) => element.tagName === 'H4' && /areas covered/i.test(element.textContent || '')
    );
    const areaContent = areaHeading?.nextElementSibling;

    if (areaHeading && areaContent) {
      const details = document.createElement('details');
      details.className = 'nmw-mobile-details';

      const summary = document.createElement('summary');
      summary.textContent = 'Areas covered';

      const content = document.createElement('div');
      content.className = 'nmw-mobile-details__content rte';
      content.append(areaContent);

      details.append(summary, content);
      areaHeading.replaceWith(details);
    }

    const bulletBlocks = [];
    let cursor = description.nextElementSibling;

    while (cursor && cursor.matches('p.product__text.inline-richtext')) {
      if ((cursor.textContent || '').trim().startsWith('•')) bulletBlocks.push(cursor);
      cursor = cursor.nextElementSibling;
    }

    if (bulletBlocks.length) {
      const details = document.createElement('details');
      details.className = 'nmw-mobile-details';

      const summary = document.createElement('summary');
      summary.textContent = 'Print and framing details';

      const content = document.createElement('div');
      content.className = 'nmw-mobile-details__content rte';
      bulletBlocks.forEach((block) => content.append(block));

      details.append(summary, content);
      description.after(details);
    }

    productInfo.dataset.nmwDetailsReady = 'true';
  };

  const buildStickyCart = (productInfo) => {
    if (!mobileQuery.matches || document.querySelector('.nmw-mobile-sticky-cart')) return;

    const sourceButton = productInfo.querySelector('.product-form__submit');
    const priceRoot = productInfo.querySelector('[id^="price-"]');
    if (!sourceButton || !priceRoot) return;

    document.body.classList.add('nmw-product-page');

    const bar = document.createElement('div');
    bar.className = 'nmw-mobile-sticky-cart';
    bar.setAttribute('aria-hidden', 'true');

    const price = document.createElement('span');
    price.className = 'nmw-mobile-sticky-cart__price';

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'button button--primary nmw-mobile-sticky-cart__button';
    button.textContent = 'Add to cart';

    bar.append(price, button);
    document.body.append(bar);

    const sync = () => {
      const visiblePrice =
        priceRoot.querySelector('.price__sale:not([hidden]) .price-item--sale') ||
        priceRoot.querySelector('.price__regular .price-item--regular') ||
        priceRoot.querySelector('.price-item--regular');

      price.textContent = visiblePrice?.textContent?.trim() || '';
      button.disabled = sourceButton.disabled;
      button.textContent = sourceButton.querySelector('span')?.textContent?.trim() || 'Add to cart';
    };

    const updateVisibility = () => {
      const shouldShow = sourceButton.getBoundingClientRect().bottom < 0;
      bar.classList.toggle('is-visible', shouldShow);
      bar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      document.body.classList.toggle('nmw-sticky-cart-visible', shouldShow);
    };

    button.addEventListener('click', () => sourceButton.click());

    new MutationObserver(sync).observe(priceRoot, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true
    });

    new MutationObserver(sync).observe(sourceButton, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true
    });

    let ticking = false;
    window.addEventListener(
      'scroll',
      () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(() => {
          updateVisibility();
          ticking = false;
        });
      },
      { passive: true }
    );

    sync();
    updateVisibility();
  };

  const init = () => {
    stabilizeAnnouncement();

    const productInfo = document.querySelector('product-info');
    if (!productInfo) return;

    buildProductDetails(productInfo);
    buildStickyCart(productInfo);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
